module.exports = __webpack_public_path__ + "static/media/hygieneplan.58f91fdf.jpg";